// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-wrapper {
  margin: 20px 0;
  overflow-x: auto;
}

.schedule-table-container {
  max-height: 200px;
  overflow-y: auto;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}

.schedule-table thead {
  position: sticky;
}

.schedule-table th,
.schedule-table td {
  padding: 10px 13px;
  text-align: center;
}

.schedule-table th:nth-child(1) {
  width: 60px;
}

.schedule-table td:nth-child(8) {
  width: 105px;
}

.estimated-amount {
  margin: 1% 1.5%;
}

.estimated-amount label,
.schedule-table th {
  font-weight: bold;
}

.estimated-amount input {
  padding: 8px;
  margin: 0 2.5%;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.schedule-table select,
.schedule-table input {
  width: 90%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.monthly-group {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 150px;
}

.monthly-group input {
  background-color: #ccc;
  padding: 2%;
  width: 60%;
}

.monthly-group span {
  margin: 2%;
}

.monthly-small input {
  background-color: #ccc;
  padding: 8%;
  width: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateProjects/MonthlyScheduleTable.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb","sourcesContent":[".schedule-wrapper {\n  margin: 20px 0;\n  overflow-x: auto;\n}\n\n.schedule-table-container {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.schedule-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: Arial, sans-serif;\n}\n\n.schedule-table thead {\n  position: sticky;\n}\n\n.schedule-table th,\n.schedule-table td {\n  padding: 10px 13px;\n  text-align: center;\n}\n\n.schedule-table th:nth-child(1) {\n  width: 60px;\n}\n\n.schedule-table td:nth-child(8) {\n  width: 105px;\n}\n\n.estimated-amount {\n  margin: 1% 1.5%;\n}\n\n.estimated-amount label,\n.schedule-table th {\n  font-weight: bold;\n}\n\n.estimated-amount input {\n  padding: 8px;\n  margin: 0 2.5%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.schedule-table select,\n.schedule-table input {\n  width: 90%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.monthly-group {\n  display: flex;\n  justify-content: space-between;\n  background-color: #fff;\n  padding: 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 150px;\n}\n\n.monthly-group input {\n  background-color: #ccc;\n  padding: 2%;\n  width: 60%;\n}\n\n.monthly-group span {\n  margin: 2%;\n}\n\n.monthly-small input {\n  background-color: #ccc;\n  padding: 8%;\n  width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
